import React from "react";
import Styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setCabinetWalletSubscribeModalStatus } from "../../../store/cabinet/action";

const CabinetSubscribeWarning = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const userData = useSelector(store => store.cabinet.userData);

    const isSubscriptionPending = userData?.subscription_status === "pending";

    const subscribeClickHandler = () => {
        if (isSubscriptionPending) return;

        dispatch(setCabinetWalletSubscribeModalStatus(true));
    };

    return (
        <div className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetCard}`}>
                <div className={Styles.warningWrap}>
                    <div className={Styles.warningTitle}>
                        {t("Активируйте аккаунт, чтобы открыть полный доступ")}
                    </div>

                    <div className={Styles.warningText}>
                        {t("Чтобы начать пользоваться платформой без ограничений, активируйте аккаунт. После активации вы получите доступ ко всем ключевым сервисам и финансовым инструментам.")}
                    </div>
                </div>

                <button
                    type="button"
                    className={`
                        ${Styles.subscribeBtn}
                        ${isSubscriptionPending ? Styles.subscribeBtnPending : ""}
                    `}
                    onClick={subscribeClickHandler}
                    disabled={isSubscriptionPending}
                >
                    {isSubscriptionPending ? (
                        <>
                            <span className={Styles.subscribeLoader} />
                            <span>{t("Ожидает подтверждения")}</span>
                        </>
                    ) : (
                        t("Активировать аккаунт")
                    )}
                </button>
            </div>
        </div>
    );
};

export default CabinetSubscribeWarning;